import {Pipe, PipeTransform} from '@angular/core';
import {PrestationType} from "@prestationType/model";

@Pipe({
  name: 'visuals',
})
export class VisualsPipe implements PipeTransform {
  transform(value: PrestationType[]): {
    name: string,
    startHours: string,
    endHours: string,
    colorText: string,
    colorBackground: string,
    id: string
  }[] {
    return value.flatMap(x => x.visualPrestationTypes.map(y => {
      return {...y, id: y.visualPrestationType_id, startHours: x.startHours, endHours: x.endHours, name: x.name};
    }));
  }
}
